import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClaimGuardService } from '../../services/claim-guard.service';

declare const $: any;

@Component({
    selector: 'app-claim-initiated-guard-modal',
    templateUrl: './claim-initiated-guard-modal.component.html',
    standalone: false
})
export class ClaimInitiatedGuardModalComponent implements OnInit, OnDestroy {
  header = '';
  body = '';
  private sub: Subscription;

  constructor(private claimGuardService: ClaimGuardService) {}

  ngOnInit(): void {
    this.sub = this.claimGuardService.guardState$.subscribe(data => {
      const modal = typeof data?.modal === 'string' ? JSON.parse(data.modal) : data?.modal;
      this.header = modal?.header || '';
      this.body = modal?.body || '';
      $('#claim-initiated-guard-modal').modal('show');
    });
  }

  onContinue(): void {
    $('#claim-initiated-guard-modal').modal('hide');
    this.claimGuardService.continueClicked$.next();
  }

  onCancel(): void {
    $('#claim-initiated-guard-modal').modal('hide');
    this.claimGuardService.cancelClicked$.next();
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
